import { API_URL } from "env";
import { toast } from "react-toastify";
import { SubscriptionType } from "../type";

async function getListSupcriptions(name: number,offset: number, limit: number) {
    const token = localStorage.getItem("token");
    try {
        if (!token) throw new Error("No token found");
        const response = await fetch(`${API_URL}api/v1/be/subscriptions`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        const data = await response.json();
        if (!data) {
            toast.error(data.message || "Failed to fetch subscriptions");
            throw new Error(data.message || "Failed to fetch subscriptions");
        }
        return data.data || [];
    }
    catch (error) {
        console.error("Error fetching subscriptions:", error);
        return [];
    }
}

export default getListSupcriptions;